export default __webpack_public_path__ + "static/media/Catamaran-Medium.0f7303e8.ttf";